import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
// import helix from './assets/helix.glb'
import gsap from 'gsap'

import vertex from './shaders/vertex'
import fragment from './shaders/fragment'
import img from './assets/line.png'
import bgImg from './assets/bgImg.png'
// import img2 from './assets/line.png'

export default class Template {
    constructor(selector) {
        this.images =[];

        // getting the heights of the containing windows
        this.container = selector;
        this.width = this.container.offsetWidth;
        this.height = this.container.offsetHeight;

        this.scene = new THREE.Scene();
        this.renderer = new THREE.WebGLRenderer({antialias: true});
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(this.width, this.height);
        this.renderer.setClearColor('#aaa', 1);
        this.renderer.physicallyCorrectLights = true;
        this.renderer.outputColorSpace = THREE.SRGBColorSpace;

        this.container.appendChild(this.renderer.domElement);

        this.camera = new THREE.PerspectiveCamera(70, this.width / this.height, 0.1, 200)
        this.camera.position.z = 4
        this.camera.position.y = 0.1

        // this.camera.fov = (2 * Math.atan((this.height / 2) / this.camera.position.z)) * (180 / Math.PI)

        // let frustumSize = 10;
        // let aspect = window.innerWidth / window.innerHeight;
        // this.camera = new THREE.OrthographicCamera(frustumSize* aspect / -2, frustumSize*aspect);
        // this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.time = 0;
        this.model = new THREE.Object3D();
        const dracoLoader = new DRACOLoader()
        dracoLoader.setDecoderPath('draco/')
        dracoLoader.setDecoderConfig({ type: 'js' })
        this.gltfLoader = new GLTFLoader()
        this.gltfLoader.setDRACOLoader(dracoLoader)

        this.paused = false;
        this.raycaster = new THREE.Raycaster()
        this.mouse = new THREE.Vector2()
        this.materials = [];
        this.gallery = new THREE.Object3D();
        
        this.setupResize();
        this.addObjects();
        // this.mouseMove()
        this.resize();
        this.render();
        // this.settings();
    }
    settings() {
        let that = this;
        this.settings = {
            time: 0,
        };
        this.gui = new dat.GUI();
        this.gui.add(this.settings, 'time', 0, 100, 0.01);
        this.gui.addImage(this.settings, 'texturePath').onChange((image) => {
            body.append(image);
        });
    }

    setupResize() {
        window.addEventListener('resize', this.resize.bind(this));
    }

    resize() {
        this.width = this.container.offsetWidth;
        this.height = this.container.offsetHeight;
        this.renderer.setSize(this.width, this.height);
        this.camera.aspect = this.width / this.height;

        const dist = this.camera.position.z
        const height = 1
        // this.camera.fov = (2 * Math.atan((this.height / 2) / this.camera.position.z)) * (180 / Math.PI)

        this.camera.updateProjectionMatrix();
    }

    addObjects() {

        this.geometry = new THREE.PlaneGeometry(4, 10, 300, 300)

        this.material = new THREE.ShaderMaterial({
            extensions: {
                derivatives: '#extension GL_OES_standard_derivatives : enable'
            },
            side: THREE.DoubleSide,
            uniforms: {
                time: { type: "f", value: 0 },
                uTexture: { type: "t", value: new THREE.TextureLoader().load(img) },
                uTexture2: { type: "t", value: new THREE.TextureLoader().load(img) },
                resolution: { type: "v4", value: new THREE.Vector4() },
                uMouse: {
                    value: new THREE.Vector2(0.5, 0.5),
                },
                uvRate: {
                    value: new THREE.Vector2(1, 1)
                }
            },
            // wireframe: true,
            side: THREE.DoubleSide,
            transparent: true,
            depthWrite:false,
            depthTest:false,
            vertexShader: vertex,
            fragmentShader: fragment
        });

        this.gltfLoader.load('/helix.glb',(gltf)=>{
            // gltf.scene.children[0].material = new THREE.MeshBasicMaterial({
            //     map: new THREE.TextureLoader().load(img),
            //     transparent: true,
            //     depthWrite:false,
            //     depthTest:false,
            // });
            this.model.add(gltf.scene)
            this.model.position.y = -12;
            this.model.position.x = 2.6;
            // this.model.position.z = -2;
            this.gallery.rotation.z = Math.PI/8;
            // this.gallery.rotation.x = Math.PI/8;
            this.gallery.add(this.model);
        },(e)=>{
            console.log(e)
        })
        console.log('woooohooo')

        this.plane = new THREE.Mesh(this.geometry,new THREE.MeshBasicMaterial({
            map: new THREE.TextureLoader().load(img),
            transparent: true,
            depthWrite:false,
            depthTest:false,
        }));
        // this.scene.add(this.plane);
        this.scene.add(this.gallery);
        this.scene.background = new THREE.TextureLoader().load(bgImg);
    }
 
    mouseMove() {
        window.addEventListener(
          "mousemove",
          (event) => {
            this.mouse.x = (event.clientX / this.width) * 2 - 1
            this.mouse.y = -(event.clientY / this.height) * 2 + 1
            // update the picking ray with the camera and mouse position
            this.raycaster.setFromCamera(this.mouse, this.camera)
            // calculate objects intersecting the picking ray
            const intersects = this.raycaster.intersectObjects(this.scene.children)
            if (intersects.length > 0) {
              gsap.to([this.material.uniforms.uMouse.value], {
                x: intersects[0].point.x,
                y: intersects[0].point.y,
                // duration: 1.2,
                // ease: "Power.easeInOut",
              })
            }
          },
          false
        )
      }

    render() {
        this.time += 0.05;
        this.model.rotation.y = this.time*0.2
        this.material.uniforms.time.value = this.time;
        requestAnimationFrame(this.render.bind(this));
        this.renderer.render(this.scene, this.camera);
    }
}

new Template(document.getElementById('container'));